<template>
  <div class="DataType">
    <div class="HotData_content">
      <!-- left -->

      <div class="type">
        <div class="type_name">{{$t("DataServer.dataClassification")}}</div>
        <ul>
          <li
            @click="toSearch(item.dataId)"
            v-for="(item, index) in Categories"
            @mouseenter="mouseenterIdx(item.dataId)"
            :key="index"
            :class="[activeId == item.dataId ? 'active' : '']"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="box_con">
        <div v-if="currentList.length > 0" class="content">
          <div v-for="(item, index) in currentList" :key="index" class="data">
            <div class="data_img" @click="toDatadetails(item.dataId)">
              <img :src="`${GLOBAL.imageUrl}${item.image}`" alt />
            </div>

            <p>{{ item.productName }}</p>
            <span>{{ item.createInsti }} </span>
          </div>
        </div>
        <div v-else class="noData">
          <img src="@/assets/image/DataHub/noData.png" alt="" />
          <p>{{$t("DataServer.noData")}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { typeDataSatList } from "@/axios/datashare.js";
import { mapMixin } from "@/util/mixin";
export default {
  mixins: [mapMixin],
  data() {
    return {
      activeId: null,
      idx: -1,
      TypeDataSatList: [],
      currentList: [],
    };
  },
  mounted() {
    this.getTypeDataSatList().then((res) => {
      this.TypeDataSatList = res.data.data.slice(0, 16);
    });
  },
  methods: {
    toSearch(dataId) {
      this.$router.push(`/dataSearch?keywords=${dataId}`);
    },
    toDatadetails(dataId) {
      // console.log(item)
      this.$router.push(`/datadetails?dataId=${dataId}`);
    },
    mouseenterIdx(val) {
      this.activeId = val;
    },
    // 最近更新数据集
    async getTypeDataSatList() {
      return await typeDataSatList();
    },
  },
  watch: {
    Categories(val) {
      // 最受欢迎数据
      this.getTypeDataSatList().then((res) => {
        this.TypeDataSatList = res.data.data;
        console.log(this.TypeDataSatList);
        this.activeId = val[0].dataId;
      });
    },
    activeId(val) {
      for (var i = 0; i < this.TypeDataSatList.length; i++) {
        if (this.TypeDataSatList[i].layer == val) {
          this.currentList = this.TypeDataSatList[i].layerList.slice(0, 12);
          return;
        } else {
          this.currentList = [];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
.active {
  background: rgba(216, 184, 121, 1) !important;
  color: #fff;
}
.DataType {
  width: 100%;
  margin: auto;
  padding: 20px;
  border-radius: 8px;
  //   height: 300px;
  background: #fff;
  //   background-size: cover;
  display: flex;
  flex-direction: column;
  .HotData_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
    i {
      margin-left: 10px;
      margin-right: 10px;
    }
    font-weight: 600;
    color: #000;
    font-size: 22px;
  }
  .HotData_content {
    display: flex;
    background: #fff;
    padding: 20px 10px;
    border-radius: 8px;
    flex-direction: row;
    display: flex;
    flex-direction: column;

    .type {
      display: flex;
      flex-direction: row;

      .type_name {
        margin-top: 4px;
        font-weight: 600;
        color: #000;
        font-size: 14px;
        // min-width: 60px;
        margin-right: 10px;
        white-space: nowrap;
      }
      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        li {
          margin-bottom: 4px;
          padding: 4px 8px;
          background: #f5f5f5;
          border-radius: 12px;
          margin-right: 10px;
          font-size: 14px;
        }
      }
    }
    .box_con {
      min-height: 460px;
    }
    .content {
      flex: 1;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 20px;
      .data:last-child {
        margin-right: 0px;
      }
      .data {
        cursor: pointer;
        overflow: hidden;
        //    width: calc((100% - 60px) / 4);
        padding: 10px;
        width: 25%;
        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
        }
        &:hover p {
          color: #d8b879;
        }
        // margin-right: 20px;

        .data_img {
          overflow: hidden;
          width: 100%;
          height: 155px;
          border-radius: 4px;
          border: 1px solid #e6e6e6;

          img {
            transition: 0.2s;
            width: 100%;
            height: 100%;
          }
        }
        p {
          width: 240px;
          margin-top: 10px;
          font-size: 14px;
          color: #000;
          // font-weight: 600;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span {
          display: inline-block;
          width: 240px;
          margin-top: 6px;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .noData {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        height: 150px;
        // width: 90px;
      }
      p {
        font-size: 16px;
        color: #ccc;
      }
    }
  }
}
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .active {
  background: rgba(216, 184, 121, 1) !important;
  color: #fff;
}
.DataType {
  width: 100%;
  margin: auto;
  padding: 20px;
  border-radius: 8px;
  //   height: 300px;
  background: #fff;
  //   background-size: cover;
  display: flex;
  flex-direction: column;
  .HotData_title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
    i {
      margin-left: 10px;
      margin-right: 10px;
    }
    font-weight: 600;
    color: #000;
    font-size: 22px;
  }
  .HotData_content {
    display: flex;
    background: #fff;
    padding: 20px 10px;
    border-radius: 8px;
    flex-direction: row;
    display: flex;
    flex-direction: column;

    .type {
      display: flex;
      flex-direction: row;

      .type_name {
        margin-top: 4px;
        font-weight: 600;
        color: #000;
        font-size: 14px;
        // min-width: 60px;
        margin-right: 10px;
        white-space: nowrap;
      }
      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        li {
          margin-bottom: 4px;
          padding: 4px 8px;
          background: #f5f5f5;
          border-radius: 12px;
          margin-right: 10px;
          font-size: 14px;
        }
      }
    }
    .box_con {
      min-height: 460px;
    }
    .content {
      flex: 1;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-top: 20px;
      .data:last-child {
        margin-right: 0px;
      }
      .data {
        cursor: pointer;
        overflow: hidden;
        //    width: calc((100% - 60px) / 4);
        padding: 10px;
        width: 25%;
        &:hover img {
          transition: 0.2s;
          transform: scale(1.1);
        }
        &:hover p {
          color: #d8b879;
        }
        // margin-right: 20px;

        .data_img {
          overflow: hidden;
          width: 100%;
          height: 155px;
          border-radius: 4px;
          border: 1px solid #e6e6e6;

          img {
            transition: 0.2s;
            width: 100%;
            height: 100%;
          }
        }
        p {
          width: 240px;
          margin-top: 10px;
          font-size: 14px;
          color: #000;
          // font-weight: 600;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span {
          display: inline-block;
          width: 240px;
          margin-top: 6px;
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
    .noData {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        height: 150px;
        // width: 90px;
      }
      p {
        font-size: 16px;
        color: #ccc;
      }
    }
  }
}
}
</style>